var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', [_vm.detect == 'pc' ? _c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("마진통계")])]) : _vm._e(), _c('v-divider', {
    staticClass: "d-md-none"
  }), _c('v-card', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', {
    class: {
      'pa-0': _vm.detect == 'pc'
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('cash-margin-list-filter')], 1), _vm.showsDescendants ? _c('div', {
    staticClass: "mb-4"
  }, [_c('cash-margin-list-member', {
    staticClass: "ml-auto mr-0",
    staticStyle: {
      "max-width": "260px"
    }
  })], 1) : _vm._e(), _c('div', [_c('v-data-table', _vm._b({
    attrs: {
      "hide-default-footer": "",
      "disable-pagination": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header, index) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value,
              item = _ref.item;
          return [_c('span', {
            key: index,
            domProps: {
              "innerHTML": _vm._s(header.formatter.bind(item)(value, item))
            }
          })];
        }
      };
    })], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false))], 1), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', _vm._b({
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    }
  }, 'v-pagination', {
    value: _vm.page,
    length: _vm.pageCount,
    'total-visible': 11
  }, false))], 1)])], 1)], 1), _c('common-loader', _vm._b({}, 'common-loader', {
    loading: _vm.loading
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }